"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};

var _default = isFunction;
exports["default"] = _default;